import { toArray } from "../../lib/functions";

export function getFieldsFromSections(sections) {
  const fields = {};

  sections.forEach((section) => {
    section.elements.forEach((element) => {
      fields[toArray(element)[0].name] = {
        ...toArray(element)[0],
        ...(toArray(element)[0].name?.includes("-traveler_")
          ? { room: section?.room ? section.room : "0-room" }
          : {}),
        value: "",
      };
    });
  });

  return fields;
}
